<div class="recomm-card">
    <div style="position: relative">
        <button class="controls p-1" (click)="recomm.isPopupOpen = !recomm.isPopupOpen" style="font-size: 1.1rem" *ngIf="showControls">
        <i class="fa-solid fa-ellipsis-v text-dark"></i>
        <div class="controls-dropdown" *ngIf="recomm.isPopupOpen">
            <!-- <button (click)="editRecommendation(recomm)"><i class="fa fa-pen mr-2"></i> <span>Edit</span></button> -->
            <button (click)="deleteRecomm(recomm)"><i class="fa fa-trash mr-2"></i> <span style="color: purple">Delete</span></button>
            <button *ngIf="isUserAdmin" (click)="promoteRecommendationToProduct(recomm)"><i class="fa fa-check mr-2"></i> Promote</button>
        </div>
        </button>

        <div class="name">
        {{ recomm.nameOfServiceProvider }}
        </div>
        <div>
        {{ recomm.company }}
        </div>
        <div class="selling-points">
        <div class="message" *ngIf="recomm.uniqueSellingPointOne">
            <i class="fa-solid fa-arrow-right mr-1"></i>
            <span>{{ recomm.uniqueSellingPointOne | slice : 0 : 50 }}</span>
        </div>

        <div class="message" *ngIf="recomm.uniqueSellingPointTwo">
            <i class="fa-solid fa-arrow-right mr-1"></i>
            <span>{{ recomm.uniqueSellingPointTwo | slice : 0 : 50 }}</span>
        </div>
        </div>
    </div>

    <div>
    <div class="company">
        <div class="d-flex flex-wrap" style="gap: 1rem;">
            <ng-container *ngFor="let loc of ['imageLocation', 'optionalImageOne', 'optionalImageTwo']">
                <img *ngIf="recomm[loc]" loading="lazy" src="{{ imageUrl + recomm[loc] }}" alt="" />
            </ng-container>
        </div>
     
     
        <span *ngIf="!recomm.imageLocation" style="width: 1px"></span>
        <!-- <div class="number">
        {{ recomm.phone }}
        </div> -->
    </div>

    <div class="recomm-card__footer">
        <button (click)="like(recomm)">{{ recomm.likeCounts }} <i class="fa fa-thumbs-up"></i></button>
    </div>
    </div>
</div>